export default __webpack_public_path__ + "static/media/ASSETS-07.342bd54f.png";